import { createFileRoute } from '@tanstack/react-router'
import { SectionHeader, useSiteScope } from '../../-section'
import { ProspectTable } from '../-parts'

export const Route = createFileRoute('/_app/$org/$host/outreach/_list/rejected')({
  component: RejectedPage,
})

function RejectedPage() {
  const { org, host, site } = useSiteScope()
  return (
    <>
      <SectionHeader title="Rejected" />
      <ProspectTable
        site={site}
        org={org}
        host={host}
        view="rejected"
        empty={{
          title: 'Nothing rejected',
          description: `No thread for ${host} has ended in a no.`,
        }}
      />
    </>
  )
}
